module.exports = __webpack_public_path__ + "img/c-thermometer-img8-3.97e09d2b.png";